export default __webpack_public_path__ + "static/media/darshanam.af6a5878.svg";